import { enableProdMode, Injector } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { akitaConfig, persistState } from '@datorama/akita';
import { AppModule } from './app/app.module';
import { TokenService } from './app/core/services/token.service';
import { AppConfig } from './app/core/services/config.service';
import { persistStateConfig } from './app/core/models/persist-state-config';

new TokenService();
new AppConfig(null, null, null);

if (environment.production) {
  enableProdMode();
}

const storage = persistState(persistStateConfig);

const providers = [{ provide: 'persistStorage', useValue: storage }];
akitaConfig({ resettable: true });

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window).then();
